var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"my-5"},[_c('h3',{staticClass:"notAllowed text-center my-5"},[_vm._v("Su contraseña ha sido cambidada")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }